module.exports = __webpack_public_path__ + "img/Flag_of_Fiji.e578698d.svg";